module.exports = __webpack_public_path__ + "static/media/dragon-tiger.3293123f.jpeg";